import { redirect } from '@sleepstation/utils'
import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import { useMutation } from 'urql'
import UserContext from '../../../context/UserContext'
import { CreateInsomniaTherapyFeedbackMutationForWrittenTestimonialMutation } from '../../../graphql/documents'
import PageNavContainer from '../../../state/PageNavContainer'
import FeedbackWrittenTestimonialPage from './FeedbackWrittenTestimonialPage'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `feedback-written-testimonial`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const handleSuccess = (url) => () => {
  redirect(url)
}

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackWrittenTestimonialModule = () => {
  const loaderData = useLoaderData()
  const { currentEnrolment } = useContext(UserContext)
  const [, setNav] = PageNavContainer.useContainer()

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
    })
  }, [setNav])

  const [, createFeedback] = useMutation(
    CreateInsomniaTherapyFeedbackMutationForWrittenTestimonialMutation
  )

  const { id } = currentEnrolment

  const createFeedbackWithVariableMapping = ({
    comments,
    author_name: authorName,
    author_location: authorLocation,
    author_job_role: authorJobRole,
    happy_to_share_age: happyToShareAge,
  }) => {
    const variables = {
      enrolmentId: id,
      comments,
      authorName,
      authorLocation,
      authorJobRole,
      happyToShareAge,
      // The handler on the backend is a generic feedback container and needs to
      // be told that this is specifically a testimonial.
      isTestimonial: true,
    }

    return createFeedback(variables)
  }

  return (
    <FeedbackWrittenTestimonialPage
      content={loaderData.page.content}
      createFeedback={createFeedbackWithVariableMapping}
      onSuccess={handleSuccess(loaderData.page.content.form.completeUrl)}
    />
  )
}

export default FeedbackWrittenTestimonialModule
